<app-font-family-loader [linkToCss]="viewModel.adobeFontFamilyCssUrl$ | async"></app-font-family-loader>

<app-card-jig
  *ngIf="viewModel.cardGrouping$ | async as data"
  [style.width.px]="viewModel.layoutInstructions$ | async | cardPreviewWidthInPx"
  [style.height.px]="viewModel.layoutInstructions$ | async | cardPreviewHeightInPx"
  [preview]="true"
  [data]="data">
</app-card-jig>
